import axios from 'axios';
import Cookies from "js-cookie";

const actions = {
  // SEE component files for examples
  async getMMData(resource, queryParams = null) {
    try {
      let loadResource = ''
      if (resource === 'stores') {
        loadResource = 'stores/list'
      } else {
        loadResource = resource
      }

      await $fetch(this.baseURL + loadResource,
        { params: queryParams },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }).then(response => {
          switch (resource) {
            case '':
              this.property = response
              break
            case 'homepage':
              this.homepage = response
              break
            case 'banners':
              this.banners = response
              break
            case 'galleries':
              this.repos = response
              break
            case 'stores':
              this.stores = response
              break
            case 'promotions':
              this.promotions = response
              break
            case 'events':
              this.events = response
              break
            case 'jobs':
              this.jobs = response
              break
            case 'categories':
              this.categories = response
              break
            case 'pages':
              this.pages = response
              break
            case 'news':
              this.news = response
              break
            case 'hours':
              this.hours = response
              break
            case 'contests':
              this.contests = response
              break
            case 'popups':
              this.popups = response
              break
            case 'blogs':
              this.blogs = response
              break
          }
        })
      return this
    } catch (error) {
      alert(error)
      console.log(error)
    }
  },
  // SEE default.vue for example
  getDataSets(list) {
    return new Promise((resolve, reject) => {
      axios.get(this.baseURL + list.url,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }).then(response => {
          resolve(response)
        }).catch(error => {
          console.log('Data load error: ' + error.message)
          reject(error)
        })
    })
  },
  async loadSeo({ url }) {
    try {
      const data = await $fetch(this.baseURL + 'meta_data?path=' + url, 
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return data
    } catch (error) {
      console.error('SEO Load Error:', error)
      return null
    }
  },
  loadPageData(list) {
    return new Promise((resolve, reject) => {
      axios.get(list.url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log('Data load error: ' + error.message)
          reject(error)
        })
    })
  },
  selectProperty(property) {
    this.selectedProperty = property
  },
  loadAuthInfo() {
    var auth = Cookies.get("auInfo");
    if (auth) {
      auth = JSON.parse(auth)
      this.authInfo = auth
    } else {
      this.authInfo = null
    }
  },
}

export default actions
